<template>
  <v-container fluid>
    <!-- <template>
      <div style="background-color: rgb(118 126 137);">
        <v-breadcrumbs :items="breadcrumbs">
            <template v-slot:divider>
                <v-icon>mdi-forward</v-icon>
            </template>
        </v-breadcrumbs>
      </div>
    </template> -->

    <v-row class="mt-2">
      <v-col cols="12">
        <v-card dark outlined>
          <v-card-title class="secondary py-1 text-subtitle-1">
            <v-icon left dense> mdi-flag </v-icon>
            Stall Configuration
            <v-spacer />
          </v-card-title>

          <v-card-text>
            <v-form ref="form" lazy-validation>
              <div class="mt-5">
                <label
                  ><B>Event Name :- </B>
                  {{
                    selectedEvent.EventName ? selectedEvent.EventName : "N/A"
                  }}</label
                >
              </div>

              <div class="mt-5">
                <label
                  ><B>StallHolder Name :- </B>
                  {{ selectStallHolder ? selectStallHolder : "N/A" }}</label
                >
              </div>

              <v-text-field
                v-model="editedItem.StallName"
                label="Stall Name"
                :rules="stallNameRules"
                required
              ></v-text-field>

              <v-row class="mb-2">
                <v-col cols="6">
                  <label>Return Home After Adding Products</label>
                  <v-combobox
                    v-model="editedItem.AddButtonReturnHome"
                    :items="AddButtonReturnHomeTypes"
                    item-text="name"
                    :return-object="false"
                    required
                  ></v-combobox>
                </v-col>
              </v-row>

              <v-row class="mb-2">
                <v-col cols="6">
                  <label>Order Numbers</label>
                  <v-combobox
                    v-model="editedItem.OrderNumbers"
                    :items="OrderNumberTypes"
                    item-text="name"
                    :return-object="false"
                    required
                  ></v-combobox>
                </v-col>
                <v-col
                  cols="5"
                  offset-md="1"
                  style="margin-top: 45px; font-size: 18px"
                >
                  <span>Inherit Stallholder Settings</span>
                </v-col>
              </v-row>

              <v-row class="mb-2">
                <v-col cols="6">
                  <v-text-field
                    v-model="editedItem.Abn"
                    label="Abn"
                    :rules="[(v) => !!v || 'Abn is required']"
                    required
                    :disabled="isSelectABN"
                  ></v-text-field>
                </v-col>

                <v-col cols="5" offset-md="1">
                  <v-checkbox
                    v-model="isSelectABN"
                    :label="eventSettings.Abn"
                    class="mr-5"
                    style="padding-top: 12px"
                  ></v-checkbox>
                </v-col>
              </v-row>

              <v-row class="mb-2">
                <v-col cols="6">
                  <label>Payment Profile</label>
                  <v-row class="ml-1">
                    <v-checkbox
                      v-model="isCashSelected"
                      label="Cash"
                      class="mr-5"
                      :disabled="isSelectPaymentProfile"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="isCardSelected"
                      label="Card"
                      class="mr-5"
                      :disabled="isSelectPaymentProfile"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="isVoucherSelected"
                      label="Voucher"
                      :disabled="isSelectPaymentProfile"
                    ></v-checkbox>
                  </v-row>
                </v-col>

                <v-col cols="5" offset-md="1">
                  <v-checkbox
                    v-model="isSelectPaymentProfile"
                    :label="eventSettings.PaymentProfile"
                    class="mr-5"
                    style="padding-top: 12px"
                  ></v-checkbox>
                </v-col>
              </v-row>

              <label>Printing Profile</label>
              <v-row class="ml-1">
                <v-col cols="6">
                  <v-row>
                    <div v-for="item in PrintingList" :key="item.id">
                      <v-checkbox
                        v-model="editedItem.PrintingProfile"
                        :label="item.name"
                        :value="item.name"
                        class="mr-5"
                        :rules="eventPrintRules"
                        required
                        :disabled="isSelectPrintingProfile"
                      ></v-checkbox>
                    </div>
                  </v-row>
                </v-col>

                <v-col cols="5" offset-md="1">
                  <v-checkbox
                    v-model="isSelectPrintingProfile"
                    :label="eventSettings.PrintingProfile"
                    class="mr-5"
                    style="margin-top: 4px; margin-left: -8px"
                  ></v-checkbox>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="6">
                  <v-combobox
                    v-model="standardDrinkLimitEnforceDisplayValue"
                    :items="EnforceTypes"
                    item-text="name"
                    item-value="name"
                    label="Drink Limit Profile"
                    :return-object="false"
                    required
                    :disabled="isSelectStandardDrinkLimitEnforce"
                  ></v-combobox>
                </v-col>
                <v-col cols="3" offset-md="1">
                  <v-checkbox
                    v-model="isSelectStandardDrinkLimitEnforce"
                    :label="
                      getEnforceTypeName(
                        eventSettings.StandardDrinkLimitEnforce
                      )
                    "
                    class="mr-5"
                  ></v-checkbox>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="editedItem.StandardDrinkLimit"
                    label="Maximum Drink Limit"
                    type="number"
                    min="0"
                    required
                    :disabled="isSelectStandardDrinkLimit"
                  ></v-text-field>
                </v-col>
                <v-col cols="3" offset-md="1">
                  <v-checkbox
                    v-model="isSelectStandardDrinkLimit"
                    :label="
                      eventSettings.StandardDrinkLimit
                        ? eventSettings.StandardDrinkLimit.toString()
                        : ''
                    "
                    class="mr-5"
                  ></v-checkbox>
                </v-col>

                <!-- <v-col cols="2">
                  <v-btn small dark style="margin-top: 25px">
                    <v-icon left x-small> mdi-calendar-clock </v-icon>
                    Schedule
                  </v-btn>
                </v-col> -->
              </v-row>

              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="editedItem.CardSurchargePercentage"
                    label="Card Surcharge Percentage"
                    type="number"
                    min="0"
                    required
                    :disabled="isSelectCardSurchargePercentage"
                  ></v-text-field>
                </v-col>

                <v-col cols="5" offset-md="1">
                  <v-checkbox
                    v-model="isSelectCardSurchargePercentage"
                    :label="
                      eventSettings.CardSurchargePercentage
                        ? eventSettings.CardSurchargePercentage.toString()
                        : ''
                    "
                    class="mr-5"
                  ></v-checkbox>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="editedItem.ManagerPin"
                    label="Manager Pin"
                    type="number"
                    min="0"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="6">
                  <global-multiple-select
                    label="Stall Tags"
                    :data-list="stallholderTagsList"
                    item-text="StallTagName"
                    item-value="StallTagId"
                    :value="editedItem.StallTags"
                    @checkSelectedList="editedItem.StallTags = $event"
                  />
                </v-col>
              </v-row>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="handleClickCancel()">
                  Cancel
                </v-btn>
                <v-btn color="blue darken-1" @click="submitForm">
                  Submit
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import "izitoast/dist/css/iziToast.min.css"; // loading css
import iziToast from "izitoast/dist/js/iziToast.min.js"; // you have access to iziToast now
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    stallData: {
      type: Object,
      default: null,
    },
    stallholderData: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    breadcrumbs: [
      {
        text: "Stall",
        disabled: false,
        href: "/StallholdersStallsStaffTerminals",
      },
      {
        text: "Stall Configuration",
        disabled: true,
        href: "",
      },
    ],
    Action: "",
    editedItem: {
      EventId: "",
      StallholderId: "",
      StallName: "",
      StandardDrinkLimit: "",
      StandardDrinkLimitEnforce: "Prompt",
      PaymentProfile: [],
      AddButtonReturnHome: "No",
      PrintingProfile: "",
      OrderNumbers: "Yes",
      CardSurchargePercentage: "",
      ManagerPin: "",
      Abn: "",
      StallTags: [],
      AbnInherit: true,
      PaymentProfileInherit: true,
      PrintingProfileInherit: true,
      CardSurchargePercentageInherit: true,
      StandardDrinkLimitInherit: true,
      StandardDrinkLimitEnforceInherit: true,
    },
    EnforceTypes: [
      { id: true, name: "Enforce" },
      { id: false, name: "Prompt" },
    ],
    AddButtonReturnHomeTypes: [
      { id: true, name: "Yes" },
      { id: false, name: "No" },
    ],
    OrderNumberTypes: [
      { id: true, name: "Yes" },
      { id: false, name: "No" },
    ],
    PrintingList: [
      {
        id: 1,
        name: "Print",
      },
      {
        id: 2,
        name: "Prompt",
      },
      {
        id: 3,
        name: "Bypass",
      },
    ],
    stallHolders: [],
    selectStallHolder: "",
    selectedStallHolderObj: {},
    ActionList: ["create", "update", "delete"],
    stallNameRules: [(v) => !!v || "Event Name is required"],
    eventPrintRules: [(v) => !!v || "Printing Profile is required"],
    eventPercentageRules: [
      (v) => (v && v > 0) || "Card Surcharge Percentage must be greater than 0",
    ],

    CSPercentageRules: [
      (v) => (v && v > 0) || "Card Surcharge Percentage must be greater than 0",
    ],

    eventSettings: {
      Abn: "",
      PaymentProfile: [],
      PrintingProfile: "",
      StandardDrinkLimit: "",
      StandardDrinkLimitEnforce: "",
      CardSurchargePercentage: "",
    },

    isSelectABN: false,
    isSelectPaymentProfile: false,
    isSelectPrintingProfile: false,
    isSelectStandardDrinkLimit: false,
    isSelectStandardDrinkLimitEnforce: false,
    isSelectCardSurchargePercentage: false,
  }),

  updated: function () {
    this.eventSettings.Abn = this.selectedStallHolderObj.Abn;
    this.eventSettings.PaymentProfile = Array.isArray(
      this.selectedStallHolderObj.PaymentProfile
    )
      ? this.selectedStallHolderObj.PaymentProfile.join(", ")
      : this.selectedStallHolderObj.PaymentProfile || "";
    this.eventSettings.PrintingProfile =
      this.selectedStallHolderObj.PrintingProfile;
    this.eventSettings.StandardDrinkLimit =
      this.selectedStallHolderObj.StandardDrinkLimit;
    this.eventSettings.StandardDrinkLimitEnforce =
      this.selectedStallHolderObj.StandardDrinkLimitEnforce;
    this.eventSettings.CardSurchargePercentage =
      this.selectedStallHolderObj.CardSurchargePercentage;
  },

  computed: {
    ...mapState("filter", [
      "globalEventFilter",
      // 'allEvents',
      "allStallHolders",
    ]),
    ...mapState("admin", ["currentStallholder", "currentStallTags"]),

    selectedEvent: {
      get() {
        return this.globalEventFilter;
      },
      set(value) {
        console.log("EVENT IS CHANGED MAKE API REQUEST 111", value);
      },
    },

    stallholderTagsList() {
      if (!this.currentStallTags || !this.editedItem.StallholderId) {
        return [];
      }
      return this.currentStallTags.filter(
        (tag) => tag.StallholderId === this.editedItem.StallholderId
      );
    },

    // events() {
    //   return this.allEvents.map((obj) => {
    //     return {text: obj.EventName, value: obj.EventId}
    //   });
    // },
    paymentProfileRules() {
      return [
        this.editedItem.PaymentProfile.length > 0 ||
          "At least one item should be selected",
      ];
    },

    isCashSelected: {
      get() {
        return (this.editedItem.PaymentProfile || []).includes("Cash");
      },
      set(value) {
        this.updatePaymentProfile("Cash", value);
      },
    },
    isCardSelected: {
      get() {
        return (this.editedItem.PaymentProfile || []).includes("Card");
      },
      set(value) {
        this.updatePaymentProfile("Card", value);
      },
    },
    isVoucherSelected: {
      get() {
        return (this.editedItem.PaymentProfile || []).includes("Voucher");
      },
      set(value) {
        this.updatePaymentProfile("Voucher", value);
      },
    },

    standardDrinkLimitEnforceDisplayValue: {
      get() {
        // Convert boolean to name for display
        let boolValue = this.editedItem.StandardDrinkLimitEnforce;

        // Handle string to boolean conversion if needed
        if (typeof boolValue === "string") {
          if (boolValue === "true" || boolValue === "Enforce") {
            boolValue = true;
          } else if (boolValue === "false" || boolValue === "Prompt") {
            boolValue = false;
          }
        }

        const enforceType = this.EnforceTypes.find(
          (type) => type.id === boolValue
        );
        return enforceType ? enforceType.name : "";
      },
      set(nameValue) {
        // Convert name back to boolean for storage
        const enforceType = this.EnforceTypes.find(
          (type) => type.name === nameValue
        );
        const boolValue = enforceType ? enforceType.id : false;
        this.editedItem.StandardDrinkLimitEnforce = boolValue;
      },
    },
  },

  watch: {
    selectedEvent(val) {
      this.handleChangeEvent(val);
    },

    isSelectABN(val) {
      if (val !== null && val === true) {
        this.editedItem.Abn = this.eventSettings.Abn;
        this.editedItem.AbnInherit = val;
      } else {
        this.editedItem.Abn = "";
        this.editedItem.AbnInherit = false;
      }
    },

    isSelectPaymentProfile(val) {
      if (val !== null && val === true) {
        console.log(
          "selectedStallHolderObj.PaymentProfile",
          this.selectedStallHolderObj.PaymentProfile
        );
        // Use the original array from selectedStallHolderObj, not the formatted string
        if (Array.isArray(this.selectedStallHolderObj.PaymentProfile)) {
          this.editedItem.PaymentProfile = [
            ...this.selectedStallHolderObj.PaymentProfile,
          ];
        } else if (
          typeof this.selectedStallHolderObj.PaymentProfile === "string"
        ) {
          var str = this.selectedStallHolderObj.PaymentProfile;
          str = str.toLowerCase().replace(/\b[a-z]/g, function (letter) {
            return letter.toUpperCase();
          });
          this.editedItem.PaymentProfile = str.split(", ");
        } else {
          this.editedItem.PaymentProfile = [];
        }
        console.log("Updated PaymentProfile:", this.editedItem.PaymentProfile);
        this.editedItem.PaymentProfileInherit = val;
      } else {
        this.editedItem.PaymentProfile = [];
        this.editedItem.PaymentProfileInherit = false;
      }
    },

    isSelectPrintingProfile(val) {
      if (val !== null && val === true) {
        this.editedItem.PrintingProfile = this.eventSettings.PrintingProfile;
        this.editedItem.PrintingProfileInherit = val;
      } else {
        this.editedItem.PrintingProfile = "";
        this.editedItem.PrintingProfileInherit = false;
      }
    },

    isSelectStandardDrinkLimit(val) {
      if (val !== null && val === true) {
        this.editedItem.StandardDrinkLimit =
          this.eventSettings.StandardDrinkLimit;
        this.editedItem.StandardDrinkLimitInherit = val;
      } else {
        this.editedItem.StandardDrinkLimit = "";
        this.editedItem.StandardDrinkLimitInherit = false;
      }
    },

    isSelectStandardDrinkLimitEnforce(val) {
      if (val !== null && val === true) {
        this.editedItem.StandardDrinkLimitEnforce =
          this.selectedStallHolderObj.StandardDrinkLimitEnforce;
        this.editedItem.StandardDrinkLimitEnforceInherit = val;
      } else {
        this.editedItem.StandardDrinkLimitEnforce = "Prompt";
        this.editedItem.StandardDrinkLimitEnforceInherit = false;
      }
    },
    isSelectCardSurchargePercentage(val) {
      if (val !== null && val === true) {
        this.editedItem.CardSurchargePercentage =
          this.eventSettings.CardSurchargePercentage;
        this.editedItem.CardSurchargePercentageInherit = val;
      } else {
        this.editedItem.CardSurchargePercentage = "";
        this.editedItem.CardSurchargePercentageInherit = false;
      }
    },
  },
  created() {
    try {
      if (this.id && this.id !== "0") {
        if (this.stallData) {
          // Use props data when available
          this.Action = "update";
          this.editedItem = { ...this.stallData };

          // Convert boolean values to string for the form
          this.editedItem.StandardDrinkLimitEnforce =
            this.editedItem.StandardDrinkLimitEnforce === true
              ? "Enforce"
              : "Prompt";
          this.editedItem.OrderNumbers =
            this.editedItem.OrderNumbers === true ? "Yes" : "No";
          this.editedItem.AddButtonReturnHome =
            this.editedItem.AddButtonReturnHome === true ? "Yes" : "No";

          // Set inherit flags
          this.editedItem.AbnInherit = this.isSelectABN;
          this.editedItem.PaymentProfileInherit = this.isSelectPaymentProfile;
          this.editedItem.PrintingProfileInherit = this.isSelectPrintingProfile;
          this.editedItem.CardSurchargePercentageInherit =
            this.isSelectCardSurchargePercentage;
          this.editedItem.StandardDrinkLimitInherit =
            this.isSelectStandardDrinkLimit;
          this.editedItem.StandardDrinkLimitEnforceInherit =
            this.isSelectStandardDrinkLimitEnforce;

          // Set stallholder data if available
          if (this.stallholderData) {
            this.selectedStallHolderObj = this.stallholderData;
            this.selectStallHolder = this.stallholderData.StallholderName;
            this.editedItem.StallholderId = this.stallholderData.StallholderId;
          }

          // Populate stall tags from stall data as an array of IDs
          const rawTags = this.stallData.StallTags || [];
          this.editedItem.StallTags = rawTags.map((t) =>
            typeof t === "object" ? t.StallTagId : t
          );
        } else {
          console.warn("Stall data not provided via props for edit mode");
          this.Action = "update";
        }
      } else {
        this.Action = "create";
        // For new stalls, use the current stallholder from the store
        if (this.currentStallholder) {
          this.selectedStallHolderObj = this.currentStallholder;
          this.selectStallHolder = this.currentStallholder.StallholderName;
          this.editedItem.StallholderId = this.currentStallholder.StallholderId;
          this.editedItem.Abn = this.currentStallholder.Abn || "";

          // Set inherit checkboxes to true by default for new stalls
          this.isSelectABN = true;
          this.isSelectPaymentProfile = true;
          this.isSelectPrintingProfile = true;
          this.isSelectStandardDrinkLimit = true;
          this.isSelectStandardDrinkLimitEnforce = true;
          this.isSelectCardSurchargePercentage = true;
        } else {
          console.warn(
            "No current stallholder selected. Please select a stallholder first."
          );
        }
      }
      this.handleStallHolder();
    } catch (error) {
      console.error("Error in created hook:", error);
      iziToast.error({
        title: "Error",
        message: "Failed to initialize stall configuration",
        position: "topRight",
      });
    }
  },

  mounted() {
    // Disable event selector while on this page
    this.setEventSelectorDisabled(true);
  },

  beforeDestroy() {
    // Re-enable event selector when leaving this page
    this.setEventSelectorDisabled(false);

    // Clean up any old localStorage data that might still exist
    localStorage.removeItem("setStallObj");
    localStorage.removeItem("setStallHolderselectObj");
  },
  methods: {
    ...mapActions("admin", ["createEvent"]),
    ...mapActions("filter", ["initialLogin"]),
    ...mapMutations("admin", [
      "setEventSelectorDisabled",
      "setCurrentEventManagementTab",
    ]),
    // haddleIsSelecters: function () {
    //   this.Abn = false;
    //   this.isSelectPaymentProfile = false;
    //   this.isSelectPrintingProfile = false;
    //   this.isSelectStandardDrinkLimit = false;
    //   this.isSelectStandardDrinkLimitEnforce = false;
    //   this.isSelectCardSurchargePercentage = false;
    // },
    handleStallHolder: function () {
      if (this.selectedEvent.EventName !== undefined) {
        this.handleChangeEvent(this.selectedEvent);
      }
    },
    handleChangeEvent: function () {
      try {
        this.stallHolders = [];
        this.editedItem.StallholderId = "";

        this.stallHolders = this.globalEventFilter.Stallholders;

        // Use props data if available, otherwise try to get from current state
        if (this.stallholderData) {
          this.selectedStallHolderObj = this.stallholderData;
          this.editedItem.StallholderId = this.stallholderData.StallholderId;
          this.selectStallHolder = this.stallholderData.StallholderName;
          if (this.editedItem.Abn === "")
            this.editedItem.Abn = this.stallholderData.Abn;
        } else if (this.currentStallholder) {
          // Fallback to current stallholder from store for new stalls
          this.selectedStallHolderObj = this.currentStallholder;
          this.editedItem.StallholderId = this.currentStallholder.StallholderId;
          this.selectStallHolder = this.currentStallholder.StallholderName;
          if (this.editedItem.Abn === "")
            this.editedItem.Abn = this.currentStallholder.Abn;
        }

        // Use stall data if available for inherit flags
        if (this.stallData) {
          this.isSelectABN = this.stallData.AbnInherit || false;
          this.isSelectPaymentProfile =
            this.stallData.PaymentProfileInherit || false;
          this.isSelectPrintingProfile =
            this.stallData.PrintingProfileInherit || false;
          this.isSelectStandardDrinkLimit =
            this.stallData.StandardDrinkLimitInherit || false;
          this.isSelectStandardDrinkLimitEnforce =
            this.stallData.StandardDrinkLimitEnforceInherit || false;
          this.isSelectCardSurchargePercentage =
            this.stallData.CardSurchargePercentageInherit || false;

          // Set values from stall data
          this.editedItem.PaymentProfile = this.stallData.PaymentProfile;
          this.editedItem.PrintingProfile = this.stallData.PrintingProfile;
          this.editedItem.StandardDrinkLimit =
            this.stallData.StandardDrinkLimit;
          this.editedItem.CardSurchargePercentage =
            this.stallData.CardSurchargePercentage;
        }

        // Set event settings from stallholder data
        if (this.selectedStallHolderObj) {
          this.eventSettings.Abn = this.selectedStallHolderObj.Abn;
          this.eventSettings.PaymentProfile = Array.isArray(
            this.selectedStallHolderObj.PaymentProfile
          )
            ? this.selectedStallHolderObj.PaymentProfile.join(", ")
            : this.selectedStallHolderObj.PaymentProfile || "";
          this.eventSettings.PrintingProfile =
            this.selectedStallHolderObj.PrintingProfile;
          this.eventSettings.StandardDrinkLimit =
            this.selectedStallHolderObj.StandardDrinkLimit;
          this.eventSettings.StandardDrinkLimitEnforce =
            this.selectedStallHolderObj.StandardDrinkLimitEnforce;
          this.eventSettings.CardSurchargePercentage =
            this.selectedStallHolderObj.CardSurchargePercentage;
        }
      } catch (error) {
        console.error("Error in handleChangeEvent:", error);
        iziToast.error({
          title: "Error",
          message: "Failed to load stallholder data",
          position: "topRight",
        });
      }
    },
    submitForm: function () {
      try {
        if (this.$refs.form.validate()) {
          this.editedItem.EventId = this.selectedEvent.EventId;
          this.editedItem.StandardDrinkLimitEnforce =
            this.editedItem.StandardDrinkLimitEnforce === "Enforce"
              ? true
              : false;
          this.editedItem.OrderNumbers =
            this.editedItem.OrderNumbers === "Yes" ? true : false;
          this.editedItem.AddButtonReturnHome =
            this.editedItem.AddButtonReturnHome === "Yes" ? true : false;

          // Create a copy of editedItem for submission
          let submissionData = { ...this.editedItem };

          // Remove Terminals property if it exists and action is update (not needed for stall configuration)
          if (this.Action === "update" && submissionData.Terminals) {
            delete submissionData.Terminals;
          }

          let event_item = [
            {
              Type: "Stall",
              Action: this.Action,
              Properties: submissionData,
            },
          ];

          let submitEvent = {
            event_items: event_item,
          };

          // console.log("submitEvent", submitEvent);

          this.createEvent(submitEvent)
            .then((response) => {
              console.log("submitForm response: ", response);

              iziToast.success({
                title: "Stall",
                message: "Successfully inserted record!",
                position: "topRight",
              });

              this.redirectReload();
            })
            .catch((err) => {
              console.log("Error:  ", err);
              iziToast.warning({
                title: "Stall",
                message: "Fail to inserted record!",
                position: "topRight",
              });
            });
        }
      } catch (e) {
        console.log(e);
      }
    },
    handleClickCancel: function () {
      // Set the current tab to "Stalls" before navigating back
      this.setCurrentEventManagementTab("Stalls");
      this.$router.push({ name: "EventManagement" });
    },
    redirectReload() {
      this.initialLogin().then((response) => {
        console.log("Initial login response:", response);
      });
      // Set the current tab to "Stalls" before navigating back
      this.setCurrentEventManagementTab("Stalls");
      // Navigate back to stalls page instead of EventManagement
      this.$router.push({ name: "EventManagement" });
    },
    updatePaymentProfile(value, checked) {
      let currentProfile = [...(this.editedItem.PaymentProfile || [])];
      if (checked) {
        if (!currentProfile.includes(value)) {
          currentProfile.push(value);
        }
      } else {
        currentProfile = currentProfile.filter((item) => item !== value);
      }
      this.editedItem.PaymentProfile = currentProfile;
    },
    getEnforceTypeName(boolValue) {
      const enforceType = this.EnforceTypes.find(
        (type) => type.id === boolValue
      );
      return enforceType ? enforceType.name : "";
    },
  },
};
</script>
